import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ArticleCard = ({ article, variant = 'default' }) => {
  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  if (variant === 'featured') {
    return (
      <article className="group relative bg-card rounded-lg literary-shadow hover:literary-shadow-elevated literary-transition overflow-hidden">
        <div className="aspect-[16/9] overflow-hidden">
          <Image
            src={article?.image}
            alt={article?.title}
            className="w-full h-full object-cover group-hover:scale-105 literary-transition sepia-overlay"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <div className="flex items-center space-x-4 mb-3">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary text-primary-foreground">
              {article?.category}
            </span>
            <span className="text-sm opacity-90">{formatDate(article?.date)}</span>
          </div>
          
          <h2 className="font-headline text-2xl font-bold mb-2 group-hover:text-accent literary-transition">
            {article?.title}
          </h2>
          
          <p className="text-sm opacity-90 mb-4 line-clamp-2">
            {article?.excerpt}
          </p>
          
          <div className="flex items-center justify-between">
            <Link
                to={`/blog/${article?.id}`}
              className="inline-flex items-center space-x-2 text-accent hover:text-white literary-transition"
            >
              <span className="font-medium">Leer más</span>
              <Icon name="ArrowRight" size={16} />
            </Link>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group bg-card rounded-lg literary-shadow hover:literary-shadow-elevated literary-transition overflow-hidden">
      <div className="aspect-[4/3] overflow-hidden">
        <Image
          src={article?.image}
          alt={article?.title}
          className="w-full h-full object-cover group-hover:scale-105 literary-transition sepia-overlay"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center space-x-4 mb-3">
          <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-primary/10 text-primary">
            {article?.category}
          </span>
          <span className="text-sm text-scholarly-gray">{formatDate(article?.date)}</span>
        </div>
        
        <h3 className="font-headline text-xl font-semibold mb-2 group-hover:text-primary literary-transition line-clamp-2">
          {article?.title}
        </h3>
        
        <p className="text-sm text-scholarly-gray mb-4 line-clamp-3">
          {article?.excerpt}
        </p>

        <div className="flex items-center justify-between">
          <Link
              to={`/blog/${article?.id}`}
            className="inline-flex items-center space-x-1 text-primary hover:text-accent literary-transition font-medium text-sm"
          >
            <span>Leer</span>
            <Icon name="ArrowRight" size={14} />
          </Link>
        </div>
      </div>
    </article>
  );
};

export default ArticleCard;